<template>
  <div class="sideSpringFrame">
    <div class="sideSpringFrame_left">
      <div class="left_top" @click="$emit('close')">
        <i class="close">×</i>
      </div>
      <div />
    </div>
    <div class="sideSpringFrame_right">
      <header class="right_titleArea">
        <h3>{{ datas.name }}</h3>
      </header>
      <main class="right_main">
        <div class="main_top">
          <div class="top_main">
            <ul class="main_box">
              <li class="box_item">
                <span class="item_text">账户名称</span>
                <input v-model.trim="struct.account_name" class="item_input">
              </li>
              <li v-for="item in datas.struct" :key="item" class="box_item">
                <span class="item_text">{{ item }}</span>
                <input v-model.trim="struct[item]" class="item_input">
              </li>
            </ul>
            <div class="main_button">
              <button class="button cancel">取消</button>
              <button class="button determine" @click="addTo">确定</button>
            </div>
          </div>
        </div>
        <el-button
          type="success"
          size="mini"
          style="margin-top: 50px; margin-left: 780px"
          @click="deleteall"
        >删除</el-button>
        <div class="main_bottom">
          <el-table
            v-loading="loading"
            :data="tableData"
            style="width: 100%; height: 100%"
            max-height="500"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55" />
            <el-table-column prop="account_name" label="账户名称">
              <template slot-scope="scope">
                <span v-if="actionId !== scope.row.id">{{
                  scope.row.account_name
                }}</span>
                <el-input v-else v-model="textName" />
              </template>
            </el-table-column>
            <el-table-column
              v-for="(value, name, index) in tableData.length
                ? tableData[0].data
                : null"
              :key="index"
              :prop="value + ''"
              :label="name"
            >
              <template slot-scope="scope">
                <span v-if="!scope.row.show">{{ scope.row.data[name] }}</span>
                <el-input v-else v-model="modifyDataQuery[name]" />
              </template>
            </el-table-column>
            <el-table-column prop="yonyou_orgunit_code" label="会计主体" />
            <el-table-column prop="yonyou_dept_code" label="部门" />
            <el-table-column
              :key="mathRandom"
              label="操作"
              align="center"
              width="350"
            >
              <template slot-scope="scope">
                <span v-show="!scope.row.show">
                  <el-button
                    type="text"
                    size="small"
                    @click.native.prevent="myJudge(scope.$index, tableData)"
                  >
                    {{ scope.row.status === 1 ? '禁用' : '启用' }}
                  </el-button>
                  <el-button
                    type="text"
                    size="small"
                    @click.native.prevent="
                      modifyAccount(scope.$index, scope.row)
                    "
                  >
                    修改
                  </el-button>
                  <el-button
                    type="text"
                    size="small"
                    @click.native.prevent="allocationAccout(scope.row, 1)"
                  >
                    用友设置（账号）
                  </el-button>
                  <el-button
                    type="text"
                    size="small"
                    @click.native.prevent="allocationAccout(scope.row, 2)"
                  >
                    用友设置（公众号）
                  </el-button>
                  <el-button
                    type="text"
                    size="small"
                    @click.native.prevent="
                      deleteAccount(scope.$index, tableData)
                    "
                  >
                    删除
                  </el-button>
                  <!-- <el-button
                    type="text"
                    size="small"
                    @click="translationgo(scope.$index, scope.row)"
                  >
                    同步微播
                  </el-button> -->
                </span>
                <span v-show="scope.row.show">
                  <el-button
                    type="text"
                    size="small"
                    @click.native.prevent="cancelAccount(scope.$index)"
                  >
                    取消修改
                  </el-button>
                  <el-button
                    type="text"
                    size="small"
                    @click.native.prevent="confirmAccount(scope.row)"
                  >
                    确认修改
                  </el-button>
                </span>
              </template>
            </el-table-column>
          </el-table>
          <Pagination :total="20" @pagination="redundancy" />
          <el-dialog
            title="平台账号设置用友参数"
            :visible.sync="dialogAccout"
            width="50%"
            :close-on-click-modal="false"
            append-to-body
          >
            <dialogAccout ref="allocation" @callbackbacer="callbackbacer" />
          </el-dialog>
          <el-dialog
            title="公众号"
            :visible.sync="dialogAccoutappid"
            width="50%"
            :close-on-click-modal="false"
            append-to-body
          >
            <dialogAppid ref="appid" @callbackbacer="callbackbacer" />
          </el-dialog>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import dialogAccout from './dialogAccout.vue'
import dialogAppid from './dialogAppid.vue'
import {
  getPlatformAccount,
  addPlatformAccount,
  disableEnable,
  deletePlatformAccount,
  modifyData,
  synchronous,
  deleteproform,
  set_yonyou
} from '@/api/providerAccountManagement/servicePorviderList.js'
import Pagination from '@/components/Pagination/index.vue'

export default {
  components: {
    Pagination,
    dialogAccout,
    dialogAppid
  },
  props: {
    datas: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      modifyDataQuery: {},
      tableData: [],
      struct: {},
      loading: false,
      mathRandom: null,
      actionId: null,
      textName: '',
      ids: [],
      dialogAccout: false,
      dialogAccoutappid: false
    }
  },
  mounted() {
    window.aa = this
    this.isHaveKey()
    this.redundancy()
  },
  methods: {
    allocationAccout(row, type) {
      if (type === 1) {
        this.dialogAccout = true
        this.$nextTick(() => {
          this.$refs.allocation.sendr(row.id, row, type)
        })
      } else {
        this.dialogAccoutappid = true
        this.$nextTick(() => {
          this.$refs.appid.sendr(row, type)
        })
      }
    },
    async callbackbacer(item) {
      console.log('item:', item)
      try {
        await set_yonyou(item)
        this.dialogAccout = false
        this.$message.success('平台账号设置成功')
      } catch (error) {
        console.log('error:', error)
      }
    },
    async myJudge(index, tableData) {
      const id = tableData[index].id
      const status = tableData[index].status
      this.loading = true
      await disableEnable(id, status === 1 ? 0 : 1)
      await this.redundancy()
      this.$message({
        message: status ? '禁用成功' : '启用成功',
        type: 'success'
      })
    },
    // 添加struct的对象键，用来判断键值是否为空
    isHaveKey() {
      this.struct = {}
      this.datas.struct.forEach((item) => {
        this.struct[item] = null
      })
      this.struct.account_name || this.$set(this.struct, 'account_name', '')
    },
    async addTo() {
      const rule = this.ruleLimit(this.struct)
      if (!rule) {
        this.isHaveKey()
        this.$message({
          message: '任一输入项都不能为空',
          type: 'error'
        })
        return
      }
      this.loading = true
      const account_name = this.struct.account_name
        ? this.struct.account_name
        : undefined
      delete this.struct.account_name
      await addPlatformAccount(this.datas.id, this.struct, account_name)
      await this.redundancy()
      this.isHaveKey()
      this.$message({
        message: '添加成功',
        type: 'success'
      })
    },
    async deleteAccount(index, tableData) {
      await deletePlatformAccount(this.tableData[index].id)
      this.$message({
        message: '删除成功',
        type: 'success'
      })
      this.actionId = null
      this.textName = ''
      await this.redundancy()
    },
    // 修改表格数据请求
    modifyTableData(id, data, account_name) {
      modifyData(id, data, account_name).then((res) => {
        this.redundancy()
      })
    },
    // 显示表格修改输入框
    modifyAccount(index, data) {
      this.modifyDataQuery = { ...data.data }
      for (let i = 0; i < this.tableData.length; i++) {
        this.tableData[i].show = false
      }
      this.tableData[index].show = true
      this.actionId = data.id
      this.textName = data.account_name
      this.mathRandom = Math.random()
    },
    // 判断请求参数是否为空的方法
    ruleLimit(data) {
      for (const item in data) {
        if (data[item] === null || data[item] === '') {
          return false
        }
      }
      return true
    },
    // 修改表格数据的确定按钮
    confirmAccount(data) {
      // 函数执行得到返回值
      const flagValue = this.ruleLimit(this.modifyDataQuery)
      if (!flagValue) {
        this.$message({
          message: '任一输入项都不能为空',
          type: 'error'
        })
      } else {
        this.modifyTableData(data.id, this.modifyDataQuery, this.textName)
        this.actionId = null
        this.textName = ''
      }
    },
    // 取消修改
    cancelAccount(index) {
      this.tableData[index].show = false
      this.actionId = null
      this.textName = ''
      this.mathRandom = Math.random()
    },
    open(data) {
      this.columnId = data.id
      this.redundancy()
    },
    async redundancy() {
      this.loading = true
      const data = await getPlatformAccount(this.datas.id)
      this.loading = false
      this.tableData = data.data
      for (let i = 0; i < this.tableData.length; i++) {
        this.tableData[i].show = false
      }
    },
    async translationgo(index, row) {
      console.log(index, row)
      const data = await synchronous({ account_id: row.id })
      console.log('data', data)
    },
    handleSelectionChange(val) {
      this.ids = []
      val.forEach((item) => {
        this.ids.push(item.id)
      })
      console.log('val', val, this.ids)
    },
    deleteall() {
      if (this.ids.length === 0) {
        this.$message.error('请选择要删除的数据')
        return
      }
      this.$confirm('您确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteproform({ ids: this.ids }).then((res) => {
          console.log('res', res)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.redundancy()
        })
      })
    }
  }
}
</script>
<style scoped lang="less">
.sideSpringFrame {
  min-width: 1200px;
  max-width: 1200px;
  min-height: 100%;
  max-height: 100%;
  height: 100%;
  background-color: #fafafa;
  -webkit-box-shadow: -4px 0 36px 0 rgb(0 0 0 / 8%),
    -1px 0 8px 0 rgb(0 0 0 / 6%), -1px 0 4px 0 rgb(0 0 0 / 2%);
  box-shadow: -4px 0 36px 0 rgb(0 0 0 / 8%), -1px 0 8px 0 rgb(0 0 0 / 6%),
    -1px 0 4px 0 rgb(0 0 0 / 2%);
  display: flex;
  z-index: 1111;
  position: fixed;
  top: 0px;
  right: 0px;
  .sideSpringFrame_left {
    width: 48px;
    height: 100%;
    background: #fff;
    -webkit-box-shadow: 1px 0 0 0 rgb(0 0 0 / 6%);
    box-shadow: 1px 0 0 0 rgb(0 0 0 / 6%);
    z-index: 2;
    .left_top {
      width: 48px;
      height: 48px;
      background: #fff;
      -webkit-box-shadow: 0 1px 0 0 hsl(0deg 0% 87% / 50%);
      box-shadow: 0 1px 0 0 hsl(0deg 0% 87% / 50%);
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-align: center;
      -webkit-box-align: center;
      align-items: center;
      -ms-flex-pack: center;
      -webkit-box-pack: center;
      justify-content: center;
      cursor: pointer;
      font-size: 19px;
      .close {
        font-style: normal;
        font-size: 30px;
      }
    }
  }

  .sideSpringFrame_right {
    width: 100%;
    .right_titleArea {
      width: 100%;
      height: 49px;
      background: #fff;
      border-bottom: 1px solid #ececec;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      padding-left: 20px;
    }

    .right_main {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-top: 49px;
      // height: calc(100% - 49px);
      flex-direction: column;
      justify-content: space-evenly;
      .main_top {
        width: 90%;
        border: 1px solid #ccc;
        background-color: #fff;
        margin: 0 auto;

        .top_main {
          padding: 10px;
          .main_box {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .box_item {
              margin: 10px 0px;
              .item_text {
                width: 100px;
                display: inline-block;
              }
              .item_input {
                width: 150px;
                height: 27px;
                outline: none;
                padding-left: 10px;
                border: 1px solid #ccc;
                &:focus {
                  border-color: #008c8c;
                }
              }
            }
          }

          .main_button {
            margin-top: 10px;
            text-align: center;
            .button {
              outline: none;
              padding: 5px 10px;
              margin: 0px 10px;
              cursor: pointer;
              &.cancel {
                border: 1px solid #ccc;
                background-color: #fff;
                &:hover {
                  background-color: #f3f0f0;
                }
              }

              &.determine {
                font-weight: 500;
                color: #fff;
                background-color: #07c160;
                -webkit-box-shadow: 0 0 0 1px rgb(0 0 0 / 15%),
                  0 2px 4px 0 rgb(0 0 0 / 10%), 0 0 0 1px #07c160;
                box-shadow: 0 0 0 1px rgb(0 0 0 / 15%),
                  0 2px 4px 0 rgb(0 0 0 / 10%), 0 0 0 1px #07c160;
                border: none;
                &:hover {
                  background-color: #07a754;
                }
              }
            }
          }
        }
      }

      .main_bottom {
        margin-top: 20px;
        width: 90%;
        height: 500px;
        border: 1px solid #ccc;
        background-color: #fff;
        /deep/ .pagination-container {
          background: #fafafa;
          margin-top: 0px;
        }
      }
    }
  }
}
</style>
